<daisy-drawer
    [(open)]="tenantService.isTenantSelectionSidebarVisibleSignal"
    (closed)="onDrawerHide()"
    title="Switch Tenant">
    <div class="flex flex-col mx-auto md:mx-0">
        <div class="w-full mb-6">
            <daisy-textbox
                [value]="tenantFilter"
                (valueChange)="onTenantFilter($event ?? '')"
                [search]="true"
                placeholder="Search by Name or ORI" />
        </div>

        @for(tenant of tenantsFiltered; track tenant.externalId) {
            <ul class="list-none m-0 p-0">
                <!-- 1. Removed (click) from <li> -->
                <li>
                    <!-- 2. Added [routerLink] and (click) handler to <a> tag -->
                    <!-- 3. [routerLink] uses ABSOLUTE path for href generation -->
                    <a class="flex mb-4 p-4 items-center border border-base-300 rounded-box hover:bg-base-300 transition-colors duration-150"
                       [routerLink]="(authService.userPrincipalComputedSignal()?.currentTenantExternalId === tenant.externalId || isSwitchingTenant || (!canAccessInactiveTenants && tenant.isActive === false)) ? null : ['/t', tenant.externalId, 'dashboard']"
                       (click)="onTenantSelect($event, tenant)"
                       [ngClass]="authService.userPrincipalComputedSignal()?.currentTenantExternalId === tenant.externalId || isSwitchingTenant  || (!canAccessInactiveTenants && tenant.isActive === false)? 'pointer-events-none opacity-70' : 'cursor-pointer'"
                       [attr.disabled]="authService.userPrincipalComputedSignal()?.currentTenantExternalId === tenant.externalId || null">
                        <span>
                            @if(authService.userPrincipalComputedSignal()?.currentTenantExternalId === tenant.externalId) {
                                <i class="fa-duotone fa-solid fa-check text-xl text-success"></i>
                            }
                            @else if(tenant.isActive === false && !canAccessInactiveTenants){
                              <i class="fa-solid fa-times text-xl text-warning"></i>
                            }
                            @else {
                                <i class="fa-regular fa-building-shield text-xl text-daisy-primary"></i>
                            }
                        </span>
                        <div class="ml-4">
                            <span class="mb-2 font-semibold">{{tenant.tenantName}}</span>
                            <p class="text-base-content/60 m-0">{{tenant.tenantOri}}</p>
                        </div>
                    </a>
                </li>
            </ul>
        }
    </div>
</daisy-drawer>
